import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { formatDate } from '../services/date-utils';
import { mapToDto } from './mapper/bewerber.mapper';
import { Bewerber, FileDocument } from '../models/bewerber.model';
import { BewerbungDto } from './dto/bewerber.dto';
import { BewerbungUnterlagen } from '../models/unterlagen.model';
import { VerificationResponseDto } from './dto/verification-response.dto';
import { ContactData } from './dto/contact-data.dto';

@Injectable({
  providedIn: 'root'
})
export class BewerberAdapter {
  public constructor(private readonly http: HttpClient) {}

  public verify(token: string, birthdate: Date): Observable<VerificationResponseDto> {
    const formattedDate: string = formatDate(birthdate);
    const params: HttpParams = new HttpParams().set('token', token).set('geburtsdatum', formattedDate);

    return this.http.get<VerificationResponseDto>('partnererfassung/bewerber/verify', { params });
  }

  public accept(pdf: string, token: string, birthdate: Date): Observable<void> {
    const formattedDate: string = formatDate(birthdate);
    const params: HttpParams = new HttpParams().set('token', token).set('geburtsdatum', formattedDate);

    return this.http.post<void>(`/api/vp/${pdf}`, null, { params });
  }

  public loadAWEManager(token: string, birthdate: Date): Observable<ContactData> {
    const formattedDate: string = formatDate(birthdate);
    const params: HttpParams = new HttpParams().set('token', token).set('geburtsdatum', formattedDate);

    return this.http.get<ContactData>('/api/vp/awe-manager', { params });
  }

  public loadVPManager(token: string, birthdate: Date): Observable<ContactData> {
    const formattedDate: string = formatDate(birthdate);
    const params: HttpParams = new HttpParams().set('token', token).set('geburtsdatum', formattedDate);

    return this.http.get<ContactData>('/api/vp/vp-manager', { params });
  }

  public sendCV(token: string, birthdate: Date, bewerber: Bewerber, unterlagen: BewerbungUnterlagen, dokumente: FileDocument[]): Observable<void> {
    const formattedGeburtsdatum: string = formatDate(birthdate);
    const params: HttpParams = new HttpParams().set('token', token).set('geburtsdatum', formattedGeburtsdatum);

    const bewerbungDto: BewerbungDto = mapToDto(bewerber, unterlagen, dokumente);
    return this.http.post<void>('/api/vp', bewerbungDto, { params });
  }
}
